module.exports = __webpack_public_path__ + "static/cercazone_none-3fec5e76130ff6d27c5b994343935554.jpg";